import {Component, OnInit, OnDestroy, ViewChild, TemplateRef} from '@angular/core';
import {NgbModal, ModalDismissReasons, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import {ActivatedRoute, Params} from '@angular/router';
import {DocumentSession} from '../../model/DocumentSession';
import {ConversionResidents} from '../../model/ConversionResidents';
import {SelectedSessionDetails} from '../../model/SelectedSessionDetails';
import {ConversionDocuments} from '../../model/ConversionDocuments';
import {ResidentDocMoveComponent} from '../resident-doc-move/resident-doc-move.component';
import {Location} from '@angular/common';
import {ConversionsReferenceDataService} from '../../services/conversions-reference-data.service';


@Component({
    selector: 're-detail-doc-transfer',
    templateUrl: './detail-doc-transfer.component.html',
    styleUrls: ['./detail-doc-transfer.component.scss'],
    standalone: false
})
export class DetailDocTransferComponent implements OnInit, OnDestroy {
  readonly documentSessionDetails = 'documentSessionDetails';
  closeResult: string;
  documentSession: DocumentSession;
  dataTable: DataTables.Api;
  sessionKey: string;
  errorDocumentList: ConversionDocuments[];
  documentsNotMoved: number;
  documentsMoved: number;
  patientName: string;
  @ViewChild('modalContent') templateRef: TemplateRef<any>;

  constructor(private modalService: NgbModal, private route: ActivatedRoute, private selectedSessionDetails: SelectedSessionDetails, private location: Location, private referenceDataService: ConversionsReferenceDataService) {
  }

  ngOnInit() {
    window['currentComponent'] = this;
    this.documentSession = <DocumentSession>JSON.parse(sessionStorage.getItem(ResidentDocMoveComponent.documentSessionDetails));
    this.sessionKey = sessionStorage.getItem(ResidentDocMoveComponent.sessionIdKey);
    this.populateDataTable();
    this.dataTable.clear();
    this.dataTable.rows.add(this.documentSession.sourceSession.residents);
    this.dataTable.draw();
  }

  ngOnDestroy(): void {
    delete window['currentComponent'];
    sessionStorage.removeItem(ResidentDocMoveComponent.documentSessionDetails);
    sessionStorage.removeItem(ResidentDocMoveComponent.sessionIdKey);
    this.dataTable.destroy();
  }

  openModal(erroredDocuments, notMovedDocs, movedDocs, residentName) {
    this.errorDocumentList = JSON.parse(decodeURIComponent(erroredDocuments));
    this.documentsNotMoved = notMovedDocs;
    this.documentsMoved = movedDocs;
    this.patientName = residentName;
    const options: NgbModalOptions = {
      // size: 'lg'
    };
    this.modalService.open(this.templateRef, options).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  private deserialize(text: string): any [] {
    return JSON.parse(text);

  }


  populateDataTable() {
    this.dataTable = $('#residentList').DataTable({
      dom:
        '<"row"<"col-sm-12"f>>' +
        '<"row"<"col-sm-12"tr>>' +
        '<"row d-none d-sm-flex"<"col-sm-12"<"float-right"p><"float-right neo-dt-l"l>>>' +
        '<"row d-flex d-sm-none"<"col-sm-6"l><"col-sm-6"p>>' +
        '<"row float-right d-none d-sm-flex"<"col-sm-12"<"float-right neo-dt-i"i>>>' +
        '<"row d-flex d-sm-none"<"col-sm-12"i>>',
      pagingType: 'full_numbers',
      language: {
        'paginate': {
          'first': '<<',
          'previous': '<',
          'next': '>',
          'last': '>>',
        },
        emptyTable: 'No Matching Records Found.',
      },
      ordering: false,
      searching: true,
      paging: true,
      info: true,
      serverSide: false,
      columns: [
        {
          title: 'Residents', render: (data: any, type: any, r: ConversionResidents) => {
            return `${r.firstName} ${r.lastName}`;
          }
        },
        {
          title: 'Total Documents', render: (data: any, type: any, r: ConversionResidents) => {
            return `${r.documentsCount}`
          }
        },
        {
          title: 'Status', render: (data: any, type: any, r: ConversionResidents) => {
            let html = ``;
            if (r.erroredDocumentList.length > 0) {
              let documentsNotMoved = r.erroredDocumentList.length;
              let documentsMoved = r.documentsCount - r.erroredDocumentList.length;
              let errorDocList = encodeURIComponent(JSON.stringify(r.erroredDocumentList));
              let residentName = (r.firstName + '  ' + r.lastName);
              html += `<span class="badge badge-danger">Error</span> ${documentsNotMoved} failed to move, ${documentsMoved} moved - <a href="javascript:" onClick="currentComponent.openModal('${errorDocList}', ${documentsNotMoved}, ${documentsMoved}, '${residentName}')">View Details</a>`;
            } else if (r.residentErrorMessage) {
              html += `<span class="badge badge-danger">Error</span> ${r.residentErrorMessage}`;
            } else {
              html += `<span class="badge badge-success">Completed</span> ${r.documentsCount} moved`;

            }
            return html;

          }

        },
      ]


    });
    new $.fn.dataTable['FixedHeader'](this.dataTable);
  }

  goBack(): void {
    this.location.back();
  }


  cancelSession() {
    this.referenceDataService.cancelSession(this.sessionKey).subscribe();
    this.location.back();

  }
}
